import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

export interface ExcluirFinanceiroDialogData {
  numeroNFSe: string;
}

/** Pede a justificativa da exclusão do financeiro do serviço tomado; fecha com o texto ou sem valor ao cancelar. */
@Component({
  selector: 'app-excluir-financeiro-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
  templateUrl: './excluir-financeiro-dialog.component.html',
  styleUrls: ['./excluir-financeiro-dialog.component.css'],
})
export class ExcluirFinanceiroDialogComponent {
  readonly justificativa = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(10), Validators.maxLength(500)],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExcluirFinanceiroDialogData,
    private dialogRef: MatDialogRef<ExcluirFinanceiroDialogComponent>
  ) { }

  public cancelar(): void {
    this.dialogRef.close();
  }

  public confirmar(): void {
    this.justificativa.markAsTouched();
    if (!this.justificativa.invalid) this.dialogRef.close(this.justificativa.value.trim());
  }
}
